import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import { group } from './ButtonGroup.scss';

const ButtonGroup: React.FC<React.PropsWithChildren> = ({ children }) => {
  const {
    data: { cmsHeaderAndGridLayout }
  } = useWizardContext();

  return cmsHeaderAndGridLayout ? <div className={group}>{children}</div> : <>{children}</>;
};

export default ButtonGroup;
